module.exports = __webpack_public_path__ + "static/media/safetymatrix.eb543281.png";